<template>
    <div class="operate-bar-wrap">
        <RoundButton @btnClick="addClick" :text="addPicture" v-if="!refercence" />
        <RoundButton @btnClick="reLoadImage" class="reLoad-image" :text="mulitAddPicture" v-if="!refercence" />
        <div class="image-clip-upload">
            <input ref="uploadinput" multiple type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" @change="imageUpload" />
        </div>
        <Select initValue="" :options="usageStatusOptions" @menuClick="usageChange" />
        <Select initValue="updateTime" :options="imgSequenceOptions" class="sequence-select" @menuClick="sequenceChange" />
        <Search :placeholder="placeholder" class="strategy-search" @searchChange="searchChange" @inputChange="searchChange"></Search>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import PictureEditModel from "./PictureEditModel";
import MultImportPictureModel from "./MultImportPictureModel";
import { imgSequenceOptions, usageStatusOptions } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import { debounce, strTrim, dataURI2Blob } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "PictureTopOperateBar",
    props: ["showAddBtn", "refercence", "tagId"],
    components: {
        RoundButton,
        Select,
        Search
    },
    data() {
        return {
            imageFileName: "",
            imageData: [],
            imageNames: [],
            imageUrl: "",
            ifHaveBigPic: false
        };
    },
    computed: {
        imgSequenceOptions() {
            return imgSequenceOptions();
        },
        usageStatusOptions() {
            return usageStatusOptions();
        },
        addPicture() {
            return this.$t("zhiji.materialLibrary.addPicBtn");
        },
        mulitAddPicture() {
            return this.$t("zhiji.materialLibrary.mulitAddPic");
        },
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        hasShowBtn() {
            if (this.showAddBtn) {
                return false;
            } else {
                return true;
            }
        }
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchPictureList(searchField);
        }, 500);
    },
    methods: {
        addClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: PictureEditModel,
                data: {
                    type: "add",
                    pictureData: {
                        tagIds: this.tagId ? this.tagId.toString() : '',
                    }
                }
            });
        },
        mulitAddClick(images, formData) {
            this.$store.dispatch("zhiji/showModal", {
                type: MultImportPictureModel,
                data: {
                    type: "add",
                    imgData: images,
                    formData: formData,
                    tagIds: this.tagId ? this.tagId.toString() : '',
                }
            });
        },
        usageChange(data) {
            this.$store.dispatch("zhiji/queryPictureList", {
                usageStatus: data.value,
                page: 1,
            });
            this.$emit('switchClick', data);
        },
        sequenceChange(data) {
            this.$store.dispatch("zhiji/queryPictureList", {
                sequence: data.value,
                page: 1
            });
            this.$emit("switchClick", data);
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchPictureList(data) {
            this.$store.dispatch("zhiji/queryPictureList", {
                pictureName: strTrim(data.value),
                page: 1
            });
            this.$emit("switchClick", data);
        },
        reLoadImage(event) {
            this.$refs.uploadinput.value = '';
            this.$refs.uploadinput.click();
        },
        imageUpload(event) {
            let imageFile = event.target.files;
            let formData = new FormData();
            for (let i = 0; i < imageFile.length; i++) {
                if (imageFile[i].size < 1024 * 1024 * 1) {
                    this.imageNames.push(imageFile[i].name);
                    formData.append("images[]", imageFile[i]);
                }
                if (imageFile[i].size > 1024 * 1024 * 1) {
                    this.ifHaveBigPic = true;
                }
            }

            if (this.ifHaveBigPic && this.imageNames.length > 0) {
                this.$message({
                    message: i18n.t("zhiji.materialLibrary.filterExceedPics"),
                    type: 'warning'
                });
            }

            if (this.imageNames.length === 0) {
                this.$message({
                    message: i18n.t("zhiji.materialLibrary.maxPicSize"),
                    type: 'warning'
                });
                return
            }
            imageFile.length > 0 && this.mulitAddClick(this.imageData, formData);
            this.imageNames = [];
            this.ifHaveBigPic = false;
        }
    }
};
</script>

<style scoped lang="less">
.operate-bar-wrap {
    padding: 10px 24px;
    border-bottom: 1px solid #d8e4f0;
    display: flex;
    align-items: center;
    background-color: #fff;
    .image-clip-upload {
        display: none;
    }
    .reLoad-image {
        margin-right: 45px;
    }
    .strategy-search {
        width: 318px;
        padding: 0;
        overflow: hidden;
        height: 32px;
    }
}
</style>
